import React from 'react';
import styled from '@emotion/styled';
import SearchField from './SearchField';
import OrdersTable, { ORDERS_TABLE_CLASS_NAME } from './OrdersTable';
import ViewHeader from './ViewHeader';
import OrderDetailsOverlay from './OrderDetailsOverlay';
import { Order } from '../models/order';
import { Location } from '../models/location';

export interface OrdersViewProps {
  onLocationSelected: any;
  onNextClicked: any;
  onPrevClicked: any;
  selectedLocationId: null | string;
  selectedStationId: null | string;
  videoTime: null | string;
  offset: number;
  locations: Location[];
  search: (query: string) => any;
  searchQuery: string;
  orders: Order[];
  selectedOrder: Order | null;
  onSelectOrder: (order: Order | null) => any;
}

const OrdersView = ({
  onLocationSelected,
  onNextClicked,
  onPrevClicked,
  selectedLocationId,
  selectedStationId,
  videoTime,
  offset,
  locations,
  search,
  searchQuery,
  orders,
  selectedOrder,
  onSelectOrder = () => { },
}: OrdersViewProps) => {

  const handleOverlayClose = () => {
    onSelectOrder(null);
  };

  const onSelectChange = (event: any) => {
    onLocationSelected(event.target.value);
  }

  const onSearchChange = (query: string) => {
    if (query === '') {
      search(query)
    }
  }

  const onSearch = (query: string) => {
    search(query);
  }

  return (
    <StyledContainer>
      <ViewHeader>
        Orders&nbsp;
        {selectedLocationId ?
          <select name="loc" onChange={onSelectChange} value={selectedLocationId} className="locationSelector">
            {locations.map(location => <option key={location.id} value={location.id}>{location.name}</option>)}
          </select> : ''}
        <SearchField
          placeholder="Order Lookup..."
          onChange={onSearchChange}
          searchText={searchQuery}
          onSearchClick={onSearch}
          onEnter={onSearch}
        />
      </ViewHeader>
      <OrdersTable
        orders={orders}
        onSelectOrder={onSelectOrder}
        highlightedOrder={selectedOrder || undefined}
      />
      <div className="pagination">{offset ? (<span><button onClick={onPrevClicked}>&lt; Prev</button> </span>) : ''}
        <button onClick={onNextClicked}>Next &gt;</button></div>
      <OrderDetailsOverlay order={selectedOrder} selectedStationId={selectedStationId} videoTime={videoTime} onClose={handleOverlayClose} />
    </StyledContainer >
  );
};

export const StyledContainer = styled.div`
  padding: 0px 60px 60px 60px;
  min-height: 100%;

  .${ORDERS_TABLE_CLASS_NAME} {
    margin-left: -45px;
    margin-right: -45px;
  }

  .pagination {
    text-align: center;
  }

  .locationSelector {
    height: 35px;
    margin-left: 25px;
    color: #6E757C;
    border-color: #6E757C;
    font-size: large;
    background-color: #F1F1F1;
    border-radius: 2px;
  }

  div.react-search-field {
    margin: 15px 50px 0px 25px;
    float: right;
  }

  input.react-search-field-input {
    width: 325px;
    height: 135px;
    border-radius: 2px;
  }
`;

export default OrdersView;
